import { Badge } from '@/components/ui/badge'

interface StatusBadgesProps {
  error: number
  warning: number
}

export const StatusBadges = ({ error, warning }: StatusBadgesProps) => {
  if (error === 0 && warning === 0) {
    return <Badge variant="secondary">0</Badge>
  }

  return Object.entries({ error, warning }).map(([key, value]) => {
    if (value === 0) return null
    const variant = key === 'error' ? 'bg-red-100 dark:bg-red-950/30' : 'bg-yellow-100 dark:bg-yellow-950/30'
    return (
      <Badge key={key} variant={'default'} className={`${variant} mr-1 text-black dark:text-white`}>
        {value}
      </Badge>
    )
  })
}
